/* ==========================================================================
   LEGIT: free gift progress bar inside the Rebuy Smart Cart
   --------------------------------------------------------------------------
   Loaded by sections/legit-gift-cart.liquid (header group), which sets
   window.LegitGift = {
     enabled, tiers: [
       { threshold (cents), name, short, image, always: true },            // Melt, everyone
       { threshold (cents), name, short, image, param, handle }            // creatine, email link only
     ]
   }

   - Everyone sees the always-on tier(s).
   - A gated tier (free creatine) only shows for visitors who arrived on its
     link (?utm_campaign=<param>, remembered for the session) or who already
     have that free gift in the cart. That mirrors the Rebuy creatine widget's
     URL rule.
   - Rebuy's own tiered progress bar is hidden with CSS. It keeps running, so
     the Melt Free Product tier still adds and removes the gift; only its
     display is replaced by this bar.

   The gifts themselves are added by Rebuy (Melt: Smart Cart tier; creatine:
   GWP widget 309633). This file only shows progress.

   SAFETY: Rebuy is a Vue app and re-renders wipe injected nodes. The observer
   is disconnected before touching the DOM and reconnected after (same pattern
   as legit-rebuy-stack.js).
   ========================================================================== */
(function () {
  'use strict';
  var C = window.LegitGift || {};
  if (!C.enabled || !Array.isArray(C.tiers) || !C.tiers.length) return;

  // remember gated links for this session
  try {
    var q = window.location.search || '';
    C.tiers.forEach(function (t) {
      if (t.param && q.indexOf('utm_campaign=' + t.param) > -1) sessionStorage.setItem('legitGift:' + t.param, '1');
    });
  } catch (e) {}

  var STYLE =
    "[data-rebuy-component='progress-bar']{display:none!important}" +
    ".legit-cart-gift{padding:12px 16px 14px;background:#fff4e0;border-bottom:1px solid #f3dfb8;font-family:var(--FONT-STACK-BODY,'Roboto',-apple-system,sans-serif)}" +
    ".legit-cart-gift__row{display:flex;align-items:center;gap:12px}" +
    ".legit-cart-gift__img{width:40px;height:40px;object-fit:contain;flex:none}" +
    ".legit-cart-gift__h{flex:1;font-size:13px;font-weight:800;line-height:1.3;color:#17181a}" +
    ".legit-cart-gift__h b{color:#c7352c;font-weight:900}" +
    ".legit-cart-gift__h s{color:#6c8c39;text-decoration:none;font-weight:900}" +
    ".legit-cart-gift__track{position:relative;height:8px;margin:12px 0 0;border-radius:999px;background:#f0dcc0}" +
    ".legit-cart-gift__fill{position:absolute;left:0;top:0;bottom:0;border-radius:999px;background:#f0483e;transition:width .35s ease}" +
    ".legit-cart-gift__mk{position:absolute;top:50%;width:16px;height:16px;margin-left:-8px;margin-top:-8px;border-radius:50%;background:#fff;border:2px solid #f0dcc0;box-sizing:border-box;display:grid;place-items:center}" +
    ".legit-cart-gift__mk.is-hit{background:#6c8c39;border-color:#6c8c39}" +
    ".legit-cart-gift__mk.is-hit::after{content:'';width:6px;height:3px;border:solid #fff;border-width:0 0 2px 2px;transform:rotate(-45deg) translate(1px,-1px)}" +
    ".legit-cart-gift__labels{position:relative;height:14px;margin-top:6px}" +
    ".legit-cart-gift__lb{position:absolute;transform:translateX(-50%);font-size:10px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#6b6f75;white-space:nowrap}" +
    ".legit-cart-gift__lb:last-child{transform:translateX(-100%)}" +
    ".legit-cart-gift__lb.is-hit{color:#6c8c39}" +
    ".legit-cart-gift--done{background:#f0483e;border-bottom:0;padding:11px 16px}" +
    ".legit-cart-gift--done .legit-cart-gift__h{color:#fff;font-weight:900;letter-spacing:.05em;text-transform:uppercase;display:flex;align-items:center;justify-content:center;gap:8px}" +
    ".legit-cart-gift--done .legit-cart-gift__img,.legit-cart-gift--done .legit-cart-gift__track,.legit-cart-gift--done .legit-cart-gift__labels{display:none}" +
    ".legit-cart-gift__readd{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px;padding:8px 10px;border-radius:8px;background:#fff;color:#17181a;font-size:12.5px;font-weight:600;letter-spacing:0;text-transform:none}" +
    ".legit-cart-gift__readd button{flex:none;border:0;border-radius:6px;background:#17181a;color:#fff;font:inherit;font-weight:800;font-size:12px;letter-spacing:.04em;text-transform:uppercase;padding:8px 12px;min-height:34px;cursor:pointer}" +
    "@media(prefers-reduced-motion:reduce){.legit-cart-gift__fill{transition:none}}";

  function injectStyle() {
    if (document.getElementById('legit-cart-gift-style')) return;
    var s = document.createElement('style');
    s.id = 'legit-cart-gift-style';
    s.textContent = STYLE;
    (document.head || document.documentElement).appendChild(s);
  }

  function money(c) { var d = (c / 100).toFixed(2); return '$' + (d.slice(-3) === '.00' ? d.slice(0, -3) : d); }
  function cart() { try { return (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) || null; } catch (e) { return null; } }
  function total(c) {
    if (!c || !Array.isArray(c.items)) return 0;
    if (typeof c.total_price === 'number') return c.total_price;
    return c.items.reduce(function (t, i) { return t + (i.final_line_price || 0); }, 0);
  }

  function activeTiers(c) {
    return C.tiers.filter(function (t) {
      if (t.always) return true;
      var flag = false;
      try { flag = sessionStorage.getItem('legitGift:' + t.param) === '1'; } catch (e) {}
      if (flag) return true;
      // already has this gift in the cart for free
      return !!(c && c.items && c.items.some(function (i) { return i.handle === t.handle && (i.final_line_price || 0) === 0; }));
    }).sort(function (a, b) { return a.threshold - b.threshold; });
  }

  function html(tiers, amt, c) {
    var max = tiers[tiers.length - 1].threshold;
    var next = null, got = [];
    tiers.forEach(function (t) { if (amt >= t.threshold) got.push(t); else if (!next) next = t; });

    var head, img = '', done = !next;
    if (done) {
      head = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>' +
        'FREE ' + got.map(function (t) { return t.short; }).join(' + ') + ' unlocked';
    } else {
      img = next.image ? '<img class="legit-cart-gift__img" src="' + next.image + '" alt="">' : '';
      head = (got.length ? '<s>&#10003; ' + got.map(function (t) { return t.short; }).join(' + ') + ' unlocked.</s> ' : '') +
        "You're <b>" + money(next.threshold - amt) + '</b> away from a FREE ' + next.name;
    }

    var track = '', labels = '';
    if (!done) {
      var pct = Math.max(3, Math.min(100, Math.round(amt / max * 100)));
      track = '<div class="legit-cart-gift__track" aria-hidden="true"><span class="legit-cart-gift__fill" style="width:' + pct + '%"></span>';
      tiers.forEach(function (t) {
        var at = Math.round(t.threshold / max * 100);
        track += '<span class="legit-cart-gift__mk' + (amt >= t.threshold ? ' is-hit' : '') + '" style="left:' + Math.min(at, 98) + '%"></span>';
        labels += '<span class="legit-cart-gift__lb' + (amt >= t.threshold ? ' is-hit' : '') + '" style="left:' + at + '%">' + money(t.threshold) + ' ' + (t.label || t.short) + '</span>';
      });
      track += '</div>';
      labels = tiers.length > 1 ? '<div class="legit-cart-gift__labels" aria-hidden="true">' + labels + '</div>' : '';
    }

    // earned but not in the cart (the shopper binned it): Rebuy only offers a Re-Add in its own
    // (hidden) bar, so surface it here and forward the click
    var readd = '';
    var missing = got.filter(function (t) {
      return t.always && t.handle && !(c && c.items && c.items.some(function (i) { return i.handle === t.handle && (i.final_line_price || 0) === 0; }));
    });
    if (missing.length && document.querySelector('.rebuy-cart__progress-gift-variant-readd')) {
      readd = '<div class="legit-cart-gift__readd"><span>Your free ' + missing[0].name + " isn't in your cart.</span>" +
        '<button type="button" data-legit-readd>Add it back</button></div>';
    }

    return { done: done, html: '<div class="legit-cart-gift__row">' + img + '<span class="legit-cart-gift__h">' + head + '</span></div>' + track + labels + readd };
  }

  var observer = null, queued = false, last = '';
  function render() {
    queued = false;
    if (observer) observer.disconnect();
    try {
      var host = document.querySelector('[data-rebuy-component="cart-items"]');
      var box = document.querySelector('[data-legit-cart-gift]');
      var c = cart();
      var hasItems = c && c.items && c.items.length > 0;
      var tiers = activeTiers(c);

      if (host && hasItems && tiers.length) {
        var out = html(tiers, total(c), c);
        if (!box || box.nextElementSibling !== host) {
          if (box) box.remove();
          box = document.createElement('div');
          box.setAttribute('data-legit-cart-gift', '');
          box.setAttribute('role', 'status');
          host.parentNode.insertBefore(box, host);
          last = '';
        }
        if (out.html !== last) {
          box.className = 'legit-cart-gift' + (out.done ? ' legit-cart-gift--done' : '');
          box.innerHTML = out.html;
          last = out.html;
        }
      } else if (box) {
        box.remove();
        last = '';
      }
    } catch (e) {
      if (window.console) console.warn('[legit-gift-cart]', e);
    } finally {
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    // rAF is paused in background tabs, so fall back to a timer there
    if (document.hidden || !window.requestAnimationFrame) setTimeout(render, 30);
    else window.requestAnimationFrame(render);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-legit-readd]');
    if (!b) return;
    var re = document.querySelector('.rebuy-cart__progress-gift-variant-readd');
    if (re) { b.disabled = true; b.textContent = 'Adding...'; re.click(); }
  });

  function start() {
    injectStyle();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:smartcart.ready', 'rebuy:smartcart.show']
      .forEach(function (ev) { document.addEventListener(ev, schedule); });
    schedule();
    setTimeout(schedule, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
